"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicBoostFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "weightedAmount",
                type: "uint256",
            },
        ],
        name: "BoostMarket",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSpeed",
                type: "uint256",
            },
        ],
        name: "BorrowSpeedUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicAccruedDelta",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "marketIndex",
                type: "uint256",
            },
        ],
        name: "DistributedReward",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "RemoveMarket",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "avgBoost",
                type: "uint256",
            },
        ],
        name: "SetAvgBoost",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSpeed",
                type: "uint256",
            },
        ],
        name: "SupplySpeedUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newWeightedAmount",
                type: "uint256",
            },
        ],
        name: "UpdateAmount",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newMultiplier",
                type: "uint256",
            },
        ],
        name: "UpdateMultiplier",
        type: "event",
    },
    {
        inputs: [],
        name: "BOOST_MULTIPLIER_PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BOOST_TYPE_LENGTH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOUBLE_PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MARKET_INITIAL_INDEX",
        outputs: [
            {
                internalType: "uint224",
                name: "",
                type: "uint224",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_BOOST_PER_USER",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_BOOST_MULTIPLIER",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "avgBoost",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "tTokens",
                type: "address[]",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType[]",
                name: "boostTypes",
                type: "uint8[]",
            },
        ],
        name: "boostMarkets",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "boostMultipliers",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "boostThresholds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "boostThresholdsCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "boostTokenBalance",
                type: "uint256",
            },
        ],
        name: "calculateBoostMultiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "multiplier",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "claimTokenHelper",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
        ],
        name: "claimTonic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
        ],
        name: "getUserBoostCollections",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
        ],
        name: "getUserInfo",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ERC20",
                name: "_tonic",
                type: "address",
            },
            {
                internalType: "address",
                name: "_vaultAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_claimTokenHelper",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType",
                name: "",
                type: "uint8",
            },
        ],
        name: "marketStates",
        outputs: [
            {
                internalType: "uint224",
                name: "index",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "block",
                type: "uint32",
            },
            {
                internalType: "uint256",
                name: "totalWeightedAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "tTokens",
                type: "address[]",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType[]",
                name: "boostTypes",
                type: "uint8[]",
            },
        ],
        name: "removeBoostMarkets",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "oldTTokens",
                type: "address[]",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType[]",
                name: "oldBoostTypes",
                type: "uint8[]",
            },
            {
                internalType: "address[]",
                name: "newTTokens",
                type: "address[]",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType[]",
                name: "newBoostTypes",
                type: "uint8[]",
            },
        ],
        name: "replaceBoostMarkets",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_avgBoost",
                type: "uint256",
            },
        ],
        name: "setAvgBoost",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_paused",
                type: "bool",
            },
        ],
        name: "setPause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "tTokens",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "_supplySpeeds",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "_borrowSpeeds",
                type: "uint256[]",
            },
        ],
        name: "setSpeeds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType",
                name: "",
                type: "uint8",
            },
        ],
        name: "speeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tonic",
        outputs: [
            {
                internalType: "contract ERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicAccrued",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
        ],
        name: "unClaimTonic",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
        ],
        name: "updateAmount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "updateMultiplier",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "userInfos",
        outputs: [
            {
                internalType: "uint256",
                name: "count",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "multiplier",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "vaultAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
class TectonicBoostFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicBoostFactory = TectonicBoostFactory;
TectonicBoostFactory.bytecode = _bytecode;
TectonicBoostFactory.abi = _abi;
//# sourceMappingURL=TectonicBoostFactory.js.map